import fs from "fs";
import path from "path";
import type { SolcatcherConfig } from "./types.js";
import { defaultConfig } from "./defaultConfig.js";

export function loadSolcatcherConfig(
  explicitPath?: string
): SolcatcherConfig {
  const configPath =
    explicitPath ??
    process.env.SOLCATCHER_CONFIG ??
    path.resolve(process.cwd(), "solcatcher.config.js");

  if (!fs.existsSync(configPath)) {
    return defaultConfig;
  }

  const userConfig = require(configPath);

  return {
    ...defaultConfig,
    ...(userConfig.default ?? userConfig),
  };
}
